import React from 'react'
import '../landingpage/landing.scss'
import Seo from '../../helmet/Helmet'
import { useParams } from 'react-router-dom';
import PopularAirlineFlights from './PopularAirlineFlights';
import AirlineFlightsSearch from './AirlineFlightsSearch';
import { airlineAssets } from './AirlineAssetsConfig';

const AirlineFlightBookingPage = ({ initialAirline }) => {

    const { airlineName } = useParams();
    const effectiveAirline = (airlineName || initialAirline || '')

    return (

        <div className="App" style={{ position: 'relative', zIndex: '0' }}>
            <Seo
                title={`Book Cheap ${effectiveAirline} Flight Tickets & Lowest Airfare Deals | Flights Booking at SuperbWorldTrip.com`}
                description={`Book ${effectiveAirline} Airlines flights at the lowest fares with SuperbWorldTrip.com. Get instant discounts, check flight status, access web check-in info & enjoy easy booking.`}
                link={`/${airlineAssets[effectiveAirline]?.slug}`}
                keywords={`${effectiveAirline} affordable flights, budget air tickets, discount flight tickets, flight booking offers, lowest airfare deals, cheapest flights online, airfare comparison, best flight deals, last-minute flight tickets, international flight bookings, flight booking discounts, airline tickets cheap, book flights online, flight reservation, best prices on flights, find cheap flights, discounted airfares, online flight booking, air ticket deals`}
                largeTwitterCard={true}
                addPostfixTitle={false}
                noIndex={true}
            />
            <AirlineFlightsSearch />
            <PopularAirlineFlights initialAirline={effectiveAirline} />
            {airlineAssets[effectiveAirline]?.content}
        </div>

    )
}

export default AirlineFlightBookingPage

